module.exports = __webpack_public_path__ + "img/completar.f5edc01c.svg";